import hexRgb from "hex-rgb";
import rgbHex from "rgb-hex";

export class Color {

    public static fromHex = (hex: string) => {
        const color = new Color();
        const rgba = hexRgb(hex);

        color.red = rgba.red;
        color.green = rgba.green;
        color.blue = rgba.blue;

        return color;
    }
    public static fromRgb = (red: number, green: number, blue: number): Color => {
        const color = new Color();

        color.red = red;
        color.green = green;
        color.blue = blue;

        return color;
    }
    public static getWhite = (): Color => new Color();

    public red: number = 255;
    public green: number = 255;
    public blue: number = 255;

    public withRed = (val: number): Color => Color.fromRgb(
        this.validValueOrDefault(val, this.red),
        this.green,
        this.blue,
    )
    public withGreen = (val: number): Color => Color.fromRgb(
        this.red,
        this.validValueOrDefault(val, this.green),
        this.blue,
    )
    public withBlue = (val: number): Color => Color.fromRgb(
        this.red,
        this.green,
        this.validValueOrDefault(val, this.blue),
    )
    public toHex = (): string => `#${rgbHex(this.red, this.green, this.blue)}`;

    private isValidValue = (val: number): boolean => Number.isInteger(val) && val <= 255 && val >= 0;

    private validValueOrDefault = (val: number, def: number) => this.isValidValue(val) ? val : def;
}

export interface IDimensions {
    width?: number;
    height?: number;
}

export interface IBorderRadius {
    topLeft?: number;
    topRight?: number;
    bottomRight?: number;
    bottomLeft?: number;
}

export interface IBorderWidth {
    left?: number;
    top?: number;
    right?: number;
    bottom?: number;
}

export interface IBorder {
    radii: IBorderRadius;
    width: IBorderWidth;
    color?: Color;
}

export interface IPadding {
    left?: number;
    top?: number;
    right?: number;
    bottom?: number;
}

export interface IStyle {
    dimensions: IDimensions;
    border: IBorder;
    padding: IPadding;
    backgroundColor?: Color;
    horizontalAlignment?: string;
    className?: string;
}

export const createEmptyStyle = (): IStyle => ({
    dimensions: {},
    border: {
        radii: {},
        width: {},
    },
    padding: {},
});

export interface ITextStyle {
    fontSize?: number;
}

export const createEmptyTextStyle = (): ITextStyle => ({
});
